<template>
    <div class="sl-main">
        <div class="sl-page sl-page--full">
            <div id="sl-cleaning-product">
                <!-- Page Header -->
                <div class="sl-page__header">
                    <div class="sl-page__title">
                        {{ $t('topographers.page_title') }}
                    </div>
                </div>

                <!-- Page Content -->
                <div class="sl-page__content text-gray-500">
                    <article-grid
                        :articles="articles"
                        :badges-callback="getBadgesCallback()"
                        hide-unit-price
                        class="w-full"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useArticleGridComposable } from '@/composables/ArticleGridComposable';
import ArticleGrid from '@/components/articles-grid/ArticleGrid.vue';
import constants from '@/constants/constants';

// ------------------------------------------------------------ COMPOSABLES

const store = useStore();
const { getBadgesCallback } = useArticleGridComposable();

// ------------------------------------------------------------ COMPUTED

const articles = computed(() => store.state.catalog.articles.filter(
    a => a.tags.some(
        t => [
            'COMPATIBLE_WITH_TOPOGRAPHER',
            'TOPOGRAPHER_DEVICE',
        ].includes(t.code)
    )
).filter(
    a => a.status !== constants.articles.status.INACTIVE
).sort(
    (a, b) => (a.extra?.sort_order ?? 0) - (b.extra?.sort_order ?? 0)
));
</script>
